import { useFormContext } from "react-hook-form";
import { ErrorMessage, PhoneNumberInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { CompaniesFormData } from "../../types";

export const CompanyContactNumberField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CompaniesFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Contact Number</Typography>
      <PhoneNumberInput control={control} name="companyContactNumber" hasError={!!errors.companyContactNumber} />
      <ErrorMessage errors={errors} name="companyContactNumber" />
    </div>
  );
};
